import React from "react";
import { AGridColDef } from "../../../../../views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { useNavigateToGivenPath } from "../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/service";
import { EyeIcon } from "../../../../../views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/EyeIcon";
import { CourseDetailsPopupById } from "../../../../../views/pages/manage/unAssigned/studentCharges/common";
import { getFormatedDate } from "../../../../../views/pages/manage/unAssigned/concessionApproval/common";
import { ReactComponent as EditIcon } from "assets/img/svg/EditGryIcon.svg";
import CustomChip from "../../../../../views/pages/manage/common/customChip/CustomChip";
import { statusChipInfo } from "./utils";
import Tooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
import { bulkTransferPolicyStyleMap } from "modules/studentTransfer/bulkTransfer/constants";


const actionNeededStatus = ["L1_SENT_CORRECTION", "L2_SENT_CORRECTION"];
const TransfersList = ({
  transferRequestsInfo,
  paginationInfo,
  getStudentTransfersList,
  handleEditTransfer,
}) => {
  const navigateToGivenPath = useNavigateToGivenPath();

  const columns = [
    new AGridColDef("psid", "PSID")
      .setMinWidth(120)
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => {
        return (
          <div
            onClick={() =>
              navigateToGivenPath(`admin/edp/studentDetails/${params?.value}`)
            }
            style={{ color: "#00B0F5", cursor: "pointer" }}
          >
            {params?.value}
          </div>
        );
      }),

    new AGridColDef("id", "TRF Request No.")
      .setMinWidth(100)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value),

    new AGridColDef("studentName", "Student Name")
      .setMinWidth(120)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value),

    new AGridColDef("businessArea", "BU")
      .setMinWidth(130)
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => {
        const { label, businessAreaDesc } = params?.value ?? {};
        return (
          <>
            <div className="mr-2">{label}</div>
            <Tooltip showOnClick={true} title={businessAreaDesc}>
              <span>
                <EyeIcon />
              </span>
            </Tooltip>
          </>
        );
      }),

    new AGridColDef("transferOutAppId", "App. ID")
      .setMinWidth(120)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value),

    new AGridColDef("outCourseId", "Course ID")
      .setMinWidth(130)
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => {
        return (
          <>
            <div className="mr-2">{params?.value}</div>
            <CourseDetailsPopupById
              courseId={params?.value}
              cta={<EyeIcon />}
            />
          </>
        );
      }),

    new AGridColDef("enrollmentType", "Enrollment Type")
      .setMinWidth(100)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value),

    new AGridColDef("transferType", "Transfer Type")
      .setMinWidth(100)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value),
    new AGridColDef("transferPolicy", "Transfer Policy")
      .setMinWidth(150)
      .setFlex(1.8)
      .editable(false)
      .renderCellComponent((params) => params?.value ? <CustomChip {...bulkTransferPolicyStyleMap[params?.value?.toUpperCase()]} style={{ textAlign : 'center'}}/> : <div>-</div>),

    new AGridColDef("effectiveDate", "Effective Date")
      .setMinWidth(120)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) =>
        getFormatedDate(params?.value, false, "DD/MM/YYYY")
      ),

    new AGridColDef("updatedOn", "Last Updated On")
      .setMinWidth(150)
      .setFlex(1.2)
      .editable(false)
      .setValueGetter((params) => {
        const dateAndTime = getFormatedDate(
          params?.value,
          false,
          "DD/MM/YYYY , hh:mm:A"
        )?.split(",");
        return `${dateAndTime[0]} at ${dateAndTime[1]} by ${params?.row?.updatedBy}`;
      }),

    new AGridColDef("approvedOn", "Approved On")
      .setMinWidth(150)
      .setFlex(1.2)
      .editable(false)
      .setValueGetter((params) => {
        const dateAndTime = getFormatedDate(
          params?.value,
          false,
          "DD/MM/YYYY , hh:mm:A"
        )?.split(",");
        return params?.value ? `${dateAndTime[0]} at ${dateAndTime[1]}` : "-";
      }),

    new AGridColDef("transferStatus", "Transfer Status", false)
      .setMinWidth(150)
      .columnAlign("center")
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => {
        const status = actionNeededStatus.includes(params?.row?.approvalStatus)
          ? "Action Needed"
          : params?.value;
     
        const info = params?.row?.remarks;
        return <CustomChip {...statusChipInfo(status, info)} />;
      }),

    new AGridColDef("action", "Action", false)
      .setMinWidth(130)
      .setFlex(1)
      .editable(false)
      .pinColumnLast(true)
      .renderCellComponent((params) => {
        const { psid, id, studentName, transferOutAppId } = params.row;
        return (
          <>
            <span
              className="cursor"
              onClick={() => {
                const url = `${
                  window.location.origin
                }/#/admin/viewTransferDetails?psid=${psid}&requestId=${id}&applicationId=${encodeURIComponent(
                  transferOutAppId
                )}&studentName=${encodeURIComponent(studentName)} `;
                // Open the new tab with the constructed URL
                window.open(url, "_blank").focus();
              }}
            >
              <EyeIcon />
            </span>
            {actionNeededStatus.includes(params?.row?.approvalStatus) && (
              <EditIcon
                className="ml-3 cursor"
                onClick={() => handleEditTransfer(params?.row)}
              />
            )}
          </>
        );
      }),
  ];

  const { totalRecords, currPage, currPageSize } = paginationInfo;
  const { data: transferRequests, loading } = transferRequestsInfo;

  return (
    <ADataGrid
      removeWrapperContainer
      rows={transferRequests || []}
      columns={columns}
      rowId={(row) => row.id}
      // rowHeight={50}
      loading={loading}
      rowCount={totalRecords}
      height ="600px"
      nextButtonHandler={(pageNo, pageSize) =>
        getStudentTransfersList({ pageNo, pageSize })
      }
      pinLastColumn
      paginationModel={{ page: currPage, pageSize: currPageSize }}
    />
  );
};

export default TransfersList;
